export enum MeasurementTool {
  SelectShape = "select-shape",
  Measurement = "measurement",
  EditShape = "edit-shape",
  DeleteShape = "delete-shape",
  CopyShape = "copy-shape",
}
